// extracted by mini-css-extract-plugin
export default {"hotelFacilitiesContainer":"property_facilities_section_hotelFacilitiesContainer__-ycGM"};